import { render } from "./SubscriptionWalletWidget.vue?vue&type=template&id=1c0989b2&scoped=true&ts=true"
import script from "./SubscriptionWalletWidget.vue?vue&type=script&lang=ts"
export * from "./SubscriptionWalletWidget.vue?vue&type=script&lang=ts"

import "./SubscriptionWalletWidget.vue?vue&type=style&index=0&id=1c0989b2&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0989b2"]])

export default __exports__